const treatments = [
  // 1. Acne
  {
    title: "Skin Disorder - Acne",
    slug: "acne",
    category: "Skin Treatment",
    description: "Acne is a chronic skin condition caused by clogged pores, bacteria, inflammation, and hormonal imbalances. It often presents as blackheads, whiteheads, pimples, nodules, or cysts that may persist without appropriate treatment.",
    image: "/Images/treatments/acne.webp",
    types: [
      { name: "Comedonal", description: "Non-inflammatory blackheads and whiteheads caused by clogged follicles.", image: "/Images/acne-type-1.webp" },
      { name: "Inflammatory", description: "Red, swollen pimples caused by bacteria and inflammation inside blocked pores.", image: "/Images/acne-type-2.webp" },
      { name: "Cystic", description: "Deep, painful nodules beneath the skin that may lead to scarring.", image: "/Images/acne-type-3.webp" }
    ],
    causes: [
      { name: "Excess oil", description: "Overactive oil glands producing too much sebum." },
      { name: "Clogged pores", description: "Dead skin and oil block follicles, trapping bacteria." },
      { name: "Bacteria", description: "P. acnes bacteria cause inflammation in blocked pores." },
      { name: "Hormones", description: "Hormonal fluctuations trigger excess oil production." }
    ],
    treat: [
      {
        name: "Topical Retinoids",
        description: `• Promote skin cell turnover to prevent pore blockages.
• Reduce formation of blackheads and whiteheads.
• Calm inflammation within skin layers.
• Prevent new acne lesions from developing.
• Improve skin texture and tone over time.
• Start with lower strengths to minimize irritation.`,
        image: "/Images/acne-treatment-1.webp"
      },
      {
        name: "Benzoyl Peroxide + Antibiotics",
        description: `• Effectively kills acne-causing bacteria (P. acnes).
• Reduces redness, swelling, and size of active pimples.
• Combination prevents antibiotic resistance.
• Available in gels, creams, or cleansers.
• Can cause dryness or bleaching of fabrics.
• Helps control both inflammatory and comedonal acne.`,
        // image: "/Images/acne-treatment-2.webp"
        // image: "/Images/treatments/acne-treatment-2.webp"
      },
      {
        name: "Oral Therapies (Isotretinoin & Hormonal)",
        description: `• Isotretinoin drastically reduces oil gland size.
• Effective for severe, scarring cystic acne.
• Hormonal therapy balances androgen levels in women.
• Requires close medical supervision and monitoring.
• Side effects may include dryness, mood changes, or lab abnormalities.
• Long-term remission is common after successful course.`,
        image: "/Images/acne-treatment-3.webp"
      },
      {
        name: "Procedural Treatments",
        description: `• Chemical peels remove surface debris and unclog pores.
• Laser therapy targets oil glands and acne scarring.
• Light therapy reduces bacterial growth without medication.
• Microdermabrasion smooths skin texture.
• Often combined with topical or oral medications.
• Require multiple sessions for visible improvement.`,
        image: "/Images/acne-treatment-4.webp"
      }
    ]
  },

  // 2. Melasma
  {
    title: "Melasma",
    slug: "melasma",
    category: "Skin Treatment",
    description: "Melasma is a pigmentation disorder characterized by brown or grayish facial patches, often triggered by sun exposure, hormonal changes, or genetic factors.",
    image: "/Images/treatments/melasma.webp",
    types: [
      { name: "Epidermal", description: "Brown patches limited to upper skin layers.", image: "/Images/melasma-type-1.webp" },
      { name: "Dermal", description: "Bluish-gray discoloration deeper in the skin.", image: "/Images/melasma-type-2.webp" },
      { name: "Mixed", description: "Combination of epidermal and dermal involvement.", image: "/Images/melasma-type-3.webp" }
    ],
    causes: [
      { name: "Sun exposure", description: "UV radiation triggers pigment production." },
      { name: "Hormones", description: "Pregnancy or birth control pills can stimulate melanin." },
      { name: "Genetics", description: "Family history increases susceptibility." }
    ],
    treat: [
      {
        name: "Topical Lightening Agents",
        description: `• Hydroquinone inhibits melanin production.
• Azelaic acid and kojic acid serve as alternatives.
• Vitamin C acts as a powerful antioxidant.
• Requires daily application for several months.
• Should be combined with strict sun protection.
• Gradual lightening occurs with consistent use.`,
        image: "/Images/melasma-treatment-1.webp"
      },
      {
        name: "Procedural Treatments",
        description: `• Chemical peels exfoliate pigmented skin layers.
• Fractional laser targets deep pigment deposits.
• Microdermabrasion smooths and lightens surface discoloration.
• Multiple sessions usually necessary for noticeable results.
• Best performed under dermatologist supervision.
• Combination with topical therapies enhances outcomes.`,
        image: "/Images/melasma-treatment-2.webp"
      },
      {
        name: "Sun Protection & Maintenance",
        description: `• Broad-spectrum sunscreen (SPF 50+) is mandatory.
• Physical blockers like zinc oxide offer best protection.
• Avoid direct sun exposure during peak hours.
• Use hats and protective clothing.
• Maintenance creams may be required long-term.
• Prevention of relapse is crucial after clearance.`,
        image: "/Images/melasma-treatment-3.webp"
      }
    ]
  },

  // 3. Psoriasis
  {
    title: "Psoriasis",
    slug: "psoriasis",
    category: "Skin Treatment",
    description: "Psoriasis is a chronic autoimmune condition leading to rapid skin cell buildup, causing scaly, red plaques with itching and discomfort. Flare-ups are often triggered by stress, infections, or environmental factors.",
     image: "/Images/treatments/Psoriasis.webp",
    types: [
      { name: "Plaque", description: "Thick, red, scaly plaques on skin surfaces.", image: "/Images/psoriasis-type-1.webp" },
      { name: "Guttate", description: "Small, drop-shaped lesions triggered by infections.", image: "/Images/psoriasis-type-2.webp" },
      { name: "Inverse", description: "Smooth, red patches in skin folds.", image: "/Images/psoriasis-type-3.webp" }
    ],
    causes: [
      { name: "Immune system", description: "Autoimmune overactivity accelerates skin cell turnover." },
      { name: "Genetics", description: "Family history plays a significant role." },
      { name: "Stress", description: "Emotional stress can trigger or worsen flares." }
    ],
    treat: [
      {
        name: "Topical Therapies",
        description: `• Corticosteroids reduce local inflammation and redness.
• Vitamin D analogues normalize skin cell growth.
• Coal tar soothes itching and reduces scaling.
• Moisturizers maintain skin barrier function.
• Topical treatments work best for mild to moderate cases.
• Long-term use requires periodic dermatologist monitoring.`,
        image: "/Images/psoriasis-treatment-1.webp"
      },
      {
        name: "Phototherapy",
        description: `• Controlled UVB light slows excessive skin growth.
• Narrowband UVB offers targeted therapy.
• Performed in clinics under professional supervision.
• Sessions given 2-3 times per week initially.
• Can induce remission lasting months to years.
• Requires eye protection and strict protocol adherence.`,
        image: "/Images/psoriasis-treatment-2.webp"
      },
      {
        name: "Systemic Biologic Therapies",
        description: `• Biologics target specific immune pathways.
• TNF inhibitors and IL-17 blockers are common options.
• Administered via injection or infusion.
• Effective for moderate-to-severe or resistant cases.
• Requires screening for infections before starting.
• Highly effective but expensive; regular monitoring required.`,
        image: "/Images/psoriasis-treatment-3.webp"
      }
    ]
  },

  // 4. Vitiligo
  {
    title: "Vitiligo",
    slug: "vitiligo",
    category: "Skin Treatment",
    description: "Vitiligo is a skin condition causing loss of pigment in patches due to destruction of melanocytes. It's usually progressive but varies widely between individuals.",
   image: "/Images/treatments/vitiligo.webp",
    types: [
      { name: "Segmental", description: "Pigment loss limited to one area or side of body.", image: "/Images/vitiligo-type-1.webp" },
      { name: "Non-segmental", description: "Symmetrical pigment loss across both sides.", image: "/Images/vitiligo-type-2.webp" }
    ],
    causes: [
      { name: "Autoimmune", description: "Immune system attacks pigment cells." },
      { name: "Genetics", description: "Family predisposition contributes to risk." },
      { name: "Stress", description: "Physical or emotional stress may trigger onset." }
    ],
    treat: [
      {
        name: "Phototherapy",
        description: `• Narrowband UVB light stimulates melanocyte activity.
• Most effective for generalized, non-segmental vitiligo.
• Requires multiple sessions per week.
• Can stabilize disease progression and repigment skin.
• Often combined with topical agents.
• Professional monitoring essential for safety and success.`,
        image: "/Images/vitiligo-treatment-1.webp"
      },
      {
        name: "Topical Therapies",
        description: `• Corticosteroids reduce local inflammation.
• Calcineurin inhibitors (tacrolimus) help restore pigment.
• Best for limited areas or facial involvement.
• Daily application for several months is common.
• Early treatment increases likelihood of repigmentation.
• Minimal side effects compared to systemic options.`,
        image: "/Images/vitiligo-treatment-2.webp"
      },
      {
        name: "Micropigmentation (Medical Tattooing)",
        description: `• Implanting pigment into depigmented skin.
• Blends white patches with surrounding skin tone.
• Useful for stable, small patches resistant to other treatments.
• Requires highly skilled specialist.
• Results are semi-permanent and may fade over years.
• Not suitable for actively spreading vitiligo.`,
        image: "/Images/vitiligo-treatment-3.webp"
      }
    ]
  },// 5. Eczema
{
  title: "Eczema (Atopic Dermatitis)",
  slug: "eczema",
  category: "Skin Treatment",
  description: "Eczema is a chronic inflammatory skin condition causing red, dry, itchy patches that may crack or ooze. It often starts in childhood and tends to flare periodically.",
 image: "/Images/treatments/Eczemia.webp",
  types: [
    { name: "Atopic", description: "Chronic, genetic form often associated with allergies or asthma.", image: "/Images/eczema-type-1.webp" },
    { name: "Contact", description: "Triggered by direct contact with irritants or allergens.", image: "/Images/eczema-type-2.webp" },
    { name: "Dyshidrotic", description: "Small, itchy blisters on hands or feet.", image: "/Images/eczema-type-3.webp" }
  ],
  causes: [
    { name: "Genetics", description: "Inherited skin barrier defects lead to dryness." },
    { name: "Immune response", description: "Overactive immune system causes inflammation." },
    { name: "Environmental factors", description: "Irritants, allergens, or climate changes trigger flares." }
  ],
  treat: [
    {
      name: "Moisturization & Skin Care",
      description: `• Daily emollient application prevents dryness and cracking.
• Thick creams or ointments lock in moisture effectively.
• Avoid hot water and harsh soaps that strip oils.
• Use gentle cleansers and fragrance-free products.
• Immediate moisturization after bathing is crucial.
• Consistent routine helps prevent frequent flare-ups.`,
      image: "/Images/eczema-treatment-1.webp"
    },
    {
      name: "Topical Anti-inflammatories",
      description: `• Corticosteroid creams reduce redness, swelling, and itching.
• Calcineurin inhibitors (tacrolimus, pimecrolimus) control inflammation without steroid risks.
• Apply directly to active lesions during flare-ups.
• Short-term use of stronger steroids, long-term use of weaker ones.
• Helps restore skin barrier when combined with moisturizers.
• Dermatologist supervision recommended to avoid side effects.`,
      image: "/Images/eczema-treatment-2.webp"
    },
    {
      name: "Lifestyle Modifications",
      description: `• Identify and avoid personal triggers (soaps, fabrics, foods).
• Wear soft, breathable clothing to reduce skin irritation.
• Maintain cool, humid indoor environment to prevent drying.
• Manage stress through relaxation techniques.
• Keep fingernails trimmed to prevent skin damage from scratching.
• Early intervention minimizes worsening during flare-ups.`,
      image: "/Images/eczema-treatment-3.webp"
    }
  ]
},

// 6. Warts
{
  title: "Warts",
  slug: "warts",
  category: "Skin Treatment",
  description: "Warts are small, rough growths caused by certain strains of the human papillomavirus (HPV). They may appear on various parts of the body and spread through skin contact.",
 image: "/Images/treatments/Warts.webp",
  types: [
    { name: "Common warts", description: "Rough, raised bumps usually on hands or fingers.", image: "/Images/warts-type-1.webp" },
    { name: "Plantar warts", description: "Hard, painful growths on soles of feet.", image: "/Images/warts-type-2.webp" },
    { name: "Flat warts", description: "Small, smooth bumps on face or limbs.", image: "/Images/warts-type-3.webp" }
  ],
  causes: [
    { name: "HPV virus", description: "Direct infection of skin cells by human papillomavirus." },
    { name: "Skin trauma", description: "Cuts or abrasions allow viral entry." },
    { name: "Weakened immunity", description: "Reduced immune response increases susceptibility." }
  ],
  treat: [
    {
      name: "Topical Treatments",
      description: `• Salicylic acid dissolves wart tissue gradually.
• Available in pads, gels, or liquid formulations.
• Requires daily application for several weeks.
• Can cause local irritation or peeling.
• Works best on smaller, superficial warts.
• Soaking the wart before application improves results.`,
      image: "/Images/warts-treatment-1.webp"
    },
    {
      name: "Cryotherapy (Freezing)",
      description: `• Liquid nitrogen freezes wart tissue, destroying infected cells.
• Done in clinic; multiple sessions often needed.
• Causes blistering and temporary discomfort.
• High success rate for common and plantar warts.
• Requires skilled practitioner to avoid skin damage.
• May require local anesthesia for painful areas.`,
      image: "/Images/warts-treatment-2.webp"
    },
    {
      name: "Advanced Destructive Procedures",
      description: `• Laser therapy vaporizes wart tissue.
• Electrosurgery burns and cuts out larger warts.
• Reserved for resistant, recurring, or large warts.
• May leave scars depending on depth of removal.
• Professional supervision critical for cosmetic areas.
• Immunotherapy injections may also be used for stubborn cases.`,
      image: "/Images/warts-treatment-3.webp"
    }
  ]
},

// 7. Fungal Infections
{
  title: "Fungal Infections",
  slug: "fungal-infections",
  category: "Skin Treatment",
  description: "Fungal skin infections occur when dermatophytes, yeasts, or molds invade the skin, nails, or scalp, causing itching, redness, and discomfort.",
 image: "/Images/treatments/Fungal.webp",
  types: [
    { name: "Ringworm (Tinea)", description: "Circular, scaly patches on skin or scalp.", image: "/Images/fungal-type-1.webp" },
    { name: "Candidiasis", description: "Yeast infection causing red, moist patches in skin folds.", image: "/Images/fungal-type-2.webp" },
    { name: "Onychomycosis", description: "Fungal nail infection leading to thick, discolored nails.", image: "/Images/fungal-type-3.webp" }
  ],
  causes: [
    { name: "Dermatophytes", description: "Fungi feeding on keratin of skin, hair, and nails." },
    { name: "Warm, moist environments", description: "Favor fungal overgrowth in skin folds or footwear." },
    { name: "Weakened immunity", description: "Increased risk in diabetes or immunosuppression." }
  ],
  treat: [
    {
      name: "Topical Antifungals",
      description: `• Clotrimazole, terbinafine, or ketoconazole creams.
• Applied directly to affected skin 1-2 times daily.
• Effective for superficial, localized infections.
• Continue treatment for several weeks after clearance.
• Clean and dry skin regularly to prevent recurrence.
• Available over-the-counter or by prescription.`,
      image: "/Images/fungal-treatment-1.webp"
    },
    {
      name: "Oral Antifungals",
      description: `• Terbinafine or itraconazole for deep or widespread infections.
• Necessary for nail and scalp involvement.
• Course may last weeks to months depending on severity.
• Requires liver function monitoring for prolonged use.
• Highly effective but risk of drug interactions.
• Professional medical supervision required.`,
      image: "/Images/fungal-treatment-2.webp"
    },
    {
      name: "Preventive Hygiene",
      description: `• Keep skin dry, especially in folds or between toes.
• Change socks, undergarments, and footwear regularly.
• Avoid sharing personal items like towels or shoes.
• Use antifungal powders for high-risk areas.
• Maintain good foot and nail hygiene.
• Early treatment prevents spreading to others.`,
      image: "/Images/fungal-treatment-3.webp"
    }
  ]
},

// 8. Rosacea
{
  title: "Rosacea",
  slug: "rosacea",
  category: "Skin Treatment",
  description: "Rosacea is a chronic facial skin condition characterized by redness, flushing, visible blood vessels, and sometimes acne-like bumps.",
  image: "/Images/treatments/rocesea.webp",
  types: [
    { name: "Erythematotelangiectatic", description: "Persistent redness and visible facial blood vessels.", image: "/Images/rosacea-type-1.webp" },
    { name: "Papulopustular", description: "Red bumps and pustules resembling acne.", image: "/Images/rosacea-type-2.webp" },
    { name: "Phymatous", description: "Thickened skin, especially on nose (rhinophyma).", image: "/Images/rosacea-type-3.webp" }
  ],
  causes: [
    { name: "Vascular dysregulation", description: "Abnormal facial blood vessel reactivity." },
    { name: "Genetic predisposition", description: "Family history increases likelihood." },
    { name: "Environmental triggers", description: "Heat, alcohol, spicy food, or stress worsen symptoms." }
  ],
  treat: [
    {
      name: "Topical Medications",
      description: `• Metronidazole and azelaic acid reduce inflammation and redness.
• Brimonidine temporarily shrinks dilated blood vessels.
• Applied once or twice daily depending on severity.
• Long-term use controls flare-ups effectively.
• Mild cases respond well to topical-only regimen.
• Minimal systemic side effects make them first-line choices.`,
      image: "/Images/rosacea-treatment-1.webp"
    },
    {
      name: "Oral Antibiotics",
      description: `• Doxycycline or minocycline reduce inflammation systemically.
• Low-dose formulations minimize antibiotic resistance.
• Effective for moderate to severe papulopustular rosacea.
• May be combined with topical treatments for faster relief.
• Typically used short-term for flare control.
• Gastrointestinal side effects possible during prolonged use.`,
      image: "/Images/rosacea-treatment-2.webp"
    },
    {
      name: "Laser & Light Therapy",
      description: `• Vascular lasers target and shrink dilated facial vessels.
• IPL (intense pulsed light) reduces flushing and redness.
• Multiple sessions required for sustained improvement.
• Excellent cosmetic results for persistent redness.
• Well-tolerated with minimal downtime.
• Long-term maintenance may require repeat sessions.`,
      image: "/Images/rosacea-treatment-3.webp"
    }
  ]
},

// 9. Alopecia Areata
{
  title: "Alopecia Areata",
  slug: "alopecia-areata",
  category: "Hair Treatment",
  description: "Alopecia Areata is an autoimmune condition where the immune system attacks hair follicles, causing sudden, patchy hair loss on the scalp or body.",
   image: "/Images/treatments/Alopecia.webp",
  types: [
    { name: "Patchy", description: "Isolated bald patches on scalp or body.", image: "/Images/alopecia-type-1.webp" },
    { name: "Totalis", description: "Complete loss of scalp hair.", image: "/Images/alopecia-type-2.webp" },
    { name: "Universalis", description: "Loss of hair across entire body.", image: "/Images/alopecia-type-3.webp" }
  ],
  causes: [
    { name: "Autoimmune attack", description: "Immune system mistakenly destroys hair follicles." },
    { name: "Genetics", description: "Family history increases risk." },
    { name: "Stress", description: "Psychological or physical stress may trigger onset." }
  ],
  treat: [
    {
      name: "Topical Corticosteroids",
      description: `• Reduce local immune attack at affected follicles.
• Applied as creams, ointments, or foams.
• Often first-line for mild, patchy cases.
• Requires consistent, long-term application.
• Response may take several months.
• Minimal systemic side effects when applied properly.`,
      image: "/Images/alopecia-treatment-1.webp"
    },
    {
      name: "Intralesional Steroid Injections",
      description: `• Direct injection of corticosteroids into bald patches.
• Effective for small, resistant areas.
• Promotes faster regrowth compared to topicals.
• Performed in clinic every 4-6 weeks.
• Temporary discomfort at injection site possible.
• Requires multiple sessions for sustained results.`,
      image: "/Images/alopecia-treatment-2.webp"
    },
    {
      name: "JAK Inhibitors (Emerging Therapy)",
      description: `• Oral or topical Janus kinase inhibitors modulate immune response.
• Promising results for severe, extensive alopecia.
• Potential side effects include infections or lab abnormalities.
• Long-term safety studies are ongoing.
• Requires specialist dermatologist supervision.
• May lead to near-complete regrowth in many patients.`,
      image: "/Images/alopecia-treatment-3.webp"
    }
  ]
}
];
// Export the treatments array for use in other components
export default treatments;